import axios from 'axios';

import type { AxiosResponse } from 'axios';
import type { ResponseError } from './types';

import { logger } from 'utils/logger';
import { isLocalStoragePossiblyBroken } from 'Redux/api';
import { signoutWhenExpiredToken } from 'Lib/Utils';

export const catchExpectedErrors = async <TResponseBody>(
    fn: () => Promise<AxiosResponse<TResponseBody>>
): Promise<AxiosResponse<TResponseBody>> => {
    try {
        return await fn();
    } catch (error) {
        logger.warn('catchExpectedErrors: error', { error });
        if (axios.isAxiosError(error) && error?.response?.status && error.response.data) {
            return error.response;
        }

        if (isLocalStoragePossiblyBroken()) {
            console.log('TRIGGERING SIGNOUT', window.location.pathname);
            window.location.href = '/signout';
        } else {
            await signoutWhenExpiredToken();
        }

        logger.error('Unknown error occurred', { error });

        // eslint-disable-next-line no-throw-literal -- We want to throw this object
        throw { title: 'Unknown error', detail: 'Something went wrong' } satisfies ResponseError;
    }
};
